/* ----------------- Firestore Naming ------------------ */
export const ENTRIES = 'tabs';
export const USERS = 'users';
export const TAGS = 'tags';

export const DATA_ADDED = 'added';
export const DATA_REMOVED = 'removed';
export const DATA_UPDATED = 'modified';
/*----------------------------------------------- */



// WEBPACK FOOTER //
// ./src/data/firebaseNaming.js